import { Box, Typography, useTheme } from '@mui/material';

import SectionTitle from './components/SectionTitle';

const contents = [
  'Tôi yêu cầu hạn chế chăm sóc cấp cứu như đã mô tả ở đây.',

  'Tôi hiểu rằng DNR có nghĩa là nếu trái tim tôi ngừng đập hoặc nếu tôi ngừng thở, không có biện pháp y tế nào để khởi động lại chức năng hô hấp hoặc tim sẽ được thực hiện.',

  'Tôi hiểu rằng quyết định này sẽ không ngăn cản tôi khỏi việc nhận được chăm sóc y tế khẩn cấp khác bởi nhân viên y tế chăm sóc cấp cứu trước bệnh viện và/hoặc chăm sóc y tế do một\nbác sĩ điều hành trước khi tôi qua đời.',

  'Tôi hiểu rằng tôi có thể thu hồi chỉ thị này bất cứ lúc nào bằng cách phá hủy biểu mẫu này hoặc bằng cách chỉ rõ rằng tôi đã thay đổi ý kiến.',

  'Tôi cho phép thông tin này được cung cấp cho bệnh viện, nhân viên cấp cứu, bác sĩ, y tá hoặc nhân viên y tế khác nếu cần thiết để thực hiện chỉ thị này.',

  `Tôi đồng ý với việc "Không Hồi Sức".`,
];

const DNRComponents = () => {
  const { palette } = useTheme();

  return (
    <>
      <SectionTitle title="Chỉ thị không hồi sức" />

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 10px auto',
        }}
      >
        {contents.map((v, i) => {
          if (i === 5) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                  color: `${palette.primary.dark}`,
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>
    </>
  );
};

export default DNRComponents;
